//Loading appropriate store cofiguration basing on ENV. because __REDUX_DEVTOOLS_EXTENSION_COMPOSE__ has to be exclusively only for DEV
if (process.env.NODE_ENV === "production") {
  module.exports = require("./configStore.prod");
} else {
  module.exports = require("./configStore.dev");
}
